import React from 'react'
import logo from '../resourses/Logo Gualtieri.svg'
import instagram from '../resourses/instagram.svg'
import facebook from '../resourses/facebook.svg'
import x from '../resourses/x.svg'
import './footer.css';

import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import NewsLetter from './NewsLetter';

const Footer = () => {
    const [serviciosOpen, setServiciosOpen] = React.useState(false)

    return (
        <footer >
            <div className="container my-5">
                <div className="row">
                    <div className="col-md-6 mt-5 d-flex f-column column-logo flex-column">
                        <Link to="/">
                        <img src={logo} alt="Logo Gualtieri" />
                    </Link>
                        <div className="d-flex align-items-center mt-3 mx-2" style={{gap: "15px"}}>
                            <a href="https://www.instagram.com/gualtieriehijos/" target="_blank" rel="noreferrer">
                                <img src={instagram} alt="Instagram" style={{width: "20px", height: "22px", objectFit: "contain"}} />
                            </a>
                            <a href="https://www.facebook.com/gualtieriehijossrl/?locale=es_LA" target="_blank" rel="noreferrer">
                                <img src={facebook} alt="Facebook" style={{width: "20px", height: "22px", objectFit: "contain"}} />
                            </a>
                            <a href="https://x.com/gualtieriehijos" target="_blank" rel="noreferrer">
                                <img src={x} alt="X" style={{width: "20px", height: "22px", objectFit: "contain"}} />
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6 mt-5 row-links-footer mt-2">
                        <div className="row">
                            <div className="text-md-left pl-4 col-md-6">
                                <Link to="/">
                                    <p className="mb-1 mr-5 pb-2">INICIO</p>
                                </Link>
                                  <div
                                    className="footer-dropdown-toggle"
                                    onClick={() => setServiciosOpen(!serviciosOpen)}
                                >
                                    <p className="mb-1 mr-5 pb-2 d-flex align-items-center" style={{cursor: "pointer"}}>
                                        SERVICIOS
                                        <span className={`footer-dropdown-arrow ${serviciosOpen ? "footer-dropdown-arrow-open" : ""}`}>
                                            ▾
                                        </span>
                                    </p>
                                </div>
                                <div className={`footer-dropdown-content ${serviciosOpen ? "footer-dropdown-content-open" : ""}`}>
                                    <Link to="/servicios/embarques">
                                        <p className="mb-1 mr-5 pb-2 pl-3">EMBARQUES</p>
                                    </Link>
                                    <Link to="/servicios/entregas">
                                        <p className="mb-1 mr-5 pb-2 pl-3">ENTREGAS</p>
                                    </Link>
                                </div>
                               
                            </div>
                            <div className="col-md-6 pl-4 text-md-left">
                              
                                 <Link to="/nosotros">
                                    <p className="mb-1 mr-5 pb-2">NOSOTROS</p>
                                </Link>
                                <HashLink to="/#contact">
                                    <p className="mb-1  mr-5 pb-2">CONTACTO</p>
                                </HashLink>
                            </div>
                        </div>
                    </div>
                  {/* <div className="col-md-4 mt-5">
                        <p>SUSCRIBITE A NUESTRO NEWSLETTER</p>
                        <p>Accedé a todas las novedades del mercado, informes semanales, 
                            reportes mensuales y  research estratégicos.</p>
                        <NewsLetter />
                    </div>*/}
                </div>
            </div>
            <div className="footer-axyoma text-center">
               
                <a href="https://axyomaglobal.com" target="_blank" rel="noreferrer"> 
                    DISEÑO by AXYOMAGLOBAL
                </a>
             
            </div>
        </footer>
    )
}

export default Footer